import React from 'react';
import { useNavigate } from 'react-router-dom';
import AccountTab from '@/components/user/AccountTab';
export default function RequiredPassword(){const nav=useNavigate();return <main dir="rtl" className="min-h-screen p-4 sm:p-8 grid place-items-center"><AccountTab forced onDone={()=>nav('/user/dashboard',{replace:true})}/></main>;}
